import LayoutDocs from './docs/layouts/layout.vue';

/**
 * Rotas para documentação dos componentes.
 */
let routes = [
    {
        path: '/docs',
        component: LayoutDocs,
        children: [
            {
                path: '',
                name: 'docs-home',
                component: () => import(/* webpackChunkName: "docs-home" */ '@/plugins/xtpgui/docs/views/home.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'roadmap',
                name: 'roadmap',
                component: () => import(/* webpackChunkName: "docs-roadmap" */ '@/plugins/xtpgui/docs/views/roadmap.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'source-code',
                name: 'source-code',
                component: () => import(/* webpackChunkName: "docs-source-code" */ '@/plugins/xtpgui/docs/views/sourcecode.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'structure',
                name: 'structure',
                component: () => import(/* webpackChunkName: "docs-structure" */ '@/plugins/xtpgui/docs/views/structure.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'themes',
                name: 'themes',
                component: () => import(/* webpackChunkName: "docs-themes" */ '@/plugins/xtpgui/docs/views/themes.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'i18n',
                name: 'i18n',
                component: () => import(/* webpackChunkName: "docs-i18n" */ '@/plugins/xtpgui/docs/views/i18n.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'utilities',
                name: 'utilities',
                component: () => import(/* webpackChunkName: "docs-utilities" */ '@/plugins/xtpgui/docs/views/utilities.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'components/authenticator',
                name: 'authenticator',
                component: () => import(/* webpackChunkName: "docs-authenticator" */ '@/plugins/xtpgui/docs/views/components/authenticator/authenticator.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'components/navbar',
                name: 'navbar',
                component: () => import(/* webpackChunkName: "docs-navbar" */ '@/plugins/xtpgui/docs/views/components/navbar/navbar.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'components/tree-menu',
                name: 'tree-menu',
                component: () => import(/* webpackChunkName: "docs-tree-menu" */ '@/plugins/xtpgui/docs/views/components/tree-menu/tree-menu.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'components/code-block/code-view',
                name: 'code-view',
                component: () => import(/* webpackChunkName: "docs-code-view" */ '@/plugins/xtpgui/docs/views/components/code-block/code-view.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'components/code-block/code-block',
                name: 'code-block',
                component: () => import(/* webpackChunkName: "docs-code-block" */ '@/plugins/xtpgui/docs/views/components/code-block/code-block.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'components/translator',
                name: 'translator',
                component: () => import(/* webpackChunkName: "docs-translator" */ '@/plugins/xtpgui/docs/views/components/translator/translator.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'components/short-btn',
                name: 'short-btn',
                component: () => import(/* webpackChunkName: "docs-short-btn" */ '@/plugins/xtpgui/docs/views/components/short-btn/short-btn.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'components/show-message',
                name: 'show-message',
                component: () => import(/* webpackChunkName: "docs-show-message" */ '@/plugins/xtpgui/docs/views/components/show-message/show-message.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'components/input-field',
                name: 'input-field',
                component: () => import(/* webpackChunkName: "docs-input-field" */ '@/plugins/xtpgui/docs/views/components/input-field/input-field.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'components/messenger',
                name: 'messenger',
                component: () => import(/* webpackChunkName: "docs-messenger" */ '@/plugins/xtpgui/docs/views/components/messenger/messenger.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'components/footerbar',
                name: 'footerbar',
                component: () => import(/* webpackChunkName: "docs-footerbar" */ '@/plugins/xtpgui/docs/views/components/footerbar/footerbar.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'components/modules-panel',
                name: 'modulespanel',
                component: () => import(/* webpackChunkName: "docs-modulespanel" */ '@/plugins/xtpgui/docs/views/components/modules-panel/modules-panel.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'components/history-panel',
                name: 'historypanel',
                component: () => import(/* webpackChunkName: "docs-historypanel" */ '@/plugins/xtpgui/docs/views/components/history-panel/history-panel.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'components/navigation-panel',
                name: 'navigationpanel',
                component: () => import(/* webpackChunkName: "docs-navigationpanel" */ '@/plugins/xtpgui/docs/views/components/navigation-panel/navigation-panel.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'components/sidebar',
                name: 'sidebar',
                component: () => import(/* webpackChunkName: "docs-sidebar" */ '@/plugins/xtpgui/docs/views/components/sidebar/sidebar.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'components/quickbar',
                name: 'quickbar',
                component: () => import(/* webpackChunkName: "docs-quickbar" */ '@/plugins/xtpgui/docs/views/components/quickbar/quickbar.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'components/app',
                name: 'app',
                component: () => import(/* webpackChunkName: "docs-app" */ '@/plugins/xtpgui/docs/views/components/app/app.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'components/page-view',
                name: 'pageview',
                component: () => import(/* webpackChunkName: "docs-pageview" */ '@/plugins/xtpgui/docs/views/components/page-view/page-view.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'components/crud-view',
                name: 'crudview',
                component: () => import(/* webpackChunkName: "docs-crudview" */ '@/plugins/xtpgui/docs/views/components/crud-view/crud-view.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'components/data-table',
                name: 'datatable',
                component: () => import(/* webpackChunkName: "docs-datatable" */ '@/plugins/xtpgui/docs/views/components/data-table/data-table.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'components/form-builder',
                name: 'formbuilder',
                component: () => import(/* webpackChunkName: "docs-formbuilder" */ '@/plugins/xtpgui/docs/views/components/form-builder/form-builder.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'components/card',
                name: 'card',
                component: () => import(/* webpackChunkName: "docs-card" */ '@/plugins/xtpgui/docs/views/components/card/card.vue'),
                meta: {
                    middleware: [],
                }
            },
            {
                path: 'components/chart-card',
                name: 'chartcard',
                component: () => import(/* webpackChunkName: "docs-chartcard" */ '@/plugins/xtpgui/docs/views/components/chart-card/chart-card.vue'),
                meta: {
                    middleware: [],
                }
            },
        ]
    },
];

const allowedHosts = [
    'localhost',
    '127.0.0.1',
    'xtpg-app.s3-website-sa-east-1.amazonaws.com'
];

if (process.env.NODE_ENV !== 'development' && !allowedHosts.filter(host => host === window.location.hostname).length) {
    routes = [{ path: '/docs', redirect: '/', }];
}

export default routes;
